import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card } from '@/components/ui/card';
import { DocumentUploadField } from './DocumentUploadField';
import { DOCUMENT_FIELDS } from './documentUploadConfig';

export const CandidateDocuments = ({ profile, onUploaded }) => {
  const { t } = useTranslation();
  return <Card className="p-4 sm:p-6 mb-6" data-testid="candidate-documents">
    <h3 className="text-xl font-semibold mb-1" data-testid="candidate-documents-heading">{t('candidateProfile.documents')}</h3>
    <p className="text-sm text-gray-600 mb-2" data-testid="candidate-documents-optional" dangerouslySetInnerHTML={{ __html: t('candidateProfile.documentsBody') }} />
    <p className="text-sm text-slate-600 mb-5" data-testid="candidate-documents-autosave">{t('candidateProfile.upload.autosaved')}</p>
    <details className="mb-5 text-sm text-slate-600" data-testid="candidate-documents-formats">
      <summary className="cursor-pointer min-h-11 py-2 text-blue-700 hover:text-blue-900 transition-colors" data-testid="candidate-documents-formats-toggle">{t('candidateProfile.upload.acceptedFormats')}</summary>
      <p className="leading-relaxed break-words" data-testid="candidate-documents-format-list">{DOCUMENT_FIELDS[0].extensions.join(', ').toUpperCase()}</p>
      <p className="mt-2" data-testid="candidate-documents-original-downloads">{t('candidateProfile.upload.originalFiles')}</p>
    </details>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      {DOCUMENT_FIELDS.map(config => {
        const stored = profile?.[config.field];
        const urls = config.multiple ? (stored || []) : stored ? [stored] : [];
        return <DocumentUploadField key={config.type} config={config} urls={urls} onUploaded={onUploaded}>
          {config.type === 'cv' && <div className="mt-3 pt-3 border-t border-blue-200/60">
            <Link to="/candidate/cv" data-testid="open-cv-builder-link" className="text-sm font-semibold text-blue-700 hover:text-blue-900 transition-colors">
              {t('candidateProfile.noCvYet')} <span className="underline underline-offset-2">{t('candidateProfile.createWithAi')}</span>
            </Link>
          </div>}
        </DocumentUploadField>;
      })}
    </div>
  </Card>;
};